const ErrorCodeConfig = {
  ERROR_SAVE_CARD_FAILED: 'checkout.lib.components.error.savedCardFaild',
  INVALID_CAPTCHA: 'checkout.lib.components.error.savedCardFaild',
};

export default ErrorCodeConfig;
